import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EditableToggle from './EditableToggle';
import nullable from '../../utils/nullable';

const findDisplayOption = (id, options) => {
  if (id === null) return null;
  const option = options.find(o => o.id === id);
  return option ? option.label : null;
};

const EditableSelect = ({
  onChange,
  value,
  submitOnBlur,
  submitOnChange,
  readOnly,
  displayValue,
  required,
  bindToId,
  options,
  placeholder,
  className,
  ...rest
}) => (
  <EditableToggle
    onSubmit={val => {
      if (bindToId || val === null) {
        onChange(val);
      } else {
        onChange(options.find(o => o.id === val));
      }
    }}
    value={bindToId ? value : value?.id}
    readOnly={readOnly}
    required={required}
    displayValue={displayValue || findDisplayOption(value, options)}
  >
    {({ inputValue, handleChange, inputRef, submit, cancel, handleKeyDown }) => (
      <select
        value={inputValue === null ? '' : inputValue}
        className={classnames('form-control', className)}
        onChange={e => {
          if (submitOnChange) {
            handleChange(e).then(submit);
          } else {
            handleChange(e);
          }
        }}
        ref={inputRef}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={handleKeyDown}
        {...rest}
      >
        {(!required || inputValue === null) && <option value="">{placeholder}</option>}

        {options.map(o => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    )}
  </EditableToggle>
);

EditableSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: nullable(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.node }),
    ]),
  ).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.node }),
  ).isRequired,
  readOnly: PropTypes.bool,
  displayValue: PropTypes.node,
  submitOnBlur: PropTypes.bool,
  submitOnChange: PropTypes.bool,
  bindToId: PropTypes.bool,
  required: PropTypes.bool,
  placeholder: PropTypes.node,
  className: PropTypes.string,
};
EditableSelect.defaultProps = {
  readOnly: false,
  displayValue: null,
  submitOnBlur: true,
  submitOnChange: true,
  bindToId: true,
  required: false,
  placeholder: null,
  className: '',
};

export default EditableSelect;
